import React from 'react';
import logoImage from '../assets/logo.png';

const Logo = ({ size = { width: 200, height: 80 } }) => {
  return (
    <img
      src={logoImage}
      alt="Virves Logo"
      style={{
        width: typeof size === 'number' ? size : size.width,
        height: typeof size === 'number' ? size : size.height,
        objectFit: 'contain'
      }}
    />
  );
};

export default Logo; 